import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=4b41a714&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=ts&"
export * from "./profile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41a714",
  null
  
)

export default component.exports